import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';

export class WaterPumpDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  renderOption(item, prefix) {
    return (
      <option key={prefix ? `${prefix}${item.id}` : item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  getWPData() {
    return this.formRef.getFormData();
  }

  render() {
    const {
      name,
      type,
      power_required,
      description,
      image,
    } = this.props.wp;

    const { t, ref, disabled, fieldErrors, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => (this.formRef = ref)}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="air-conditioning-water-pump-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder="Name"
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-water-pump-type"
          field="type"
          componentClass="select"
          label={t('water pump type')}
          placeholder={t('water pump type')}
          value={type}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.types.map(type => this.renderOption(type, 'wp'))}
        </FieldGroup>
        <FieldGroup
          id="air-conditioning-water-pump-power-required"
          field="power_required"
          type="number"
          label={t('power (kW)')}
          placeholder="12"
          value={power_required}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'power_required')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-water-pump-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

WaterPumpDetail.defaultProps = {
  wp: {},
};

const mapStateToProps = state => ({
  types: state.reference.ac.wpTypes,
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    null,
    null,
    { withRef: true },
  )(WaterPumpDetail),
);



// WEBPACK FOOTER //
// ./src/components/ac_central/WaterPumpDetail.js